import React, { Component } from "react";
import { connect } from "react-redux";
import autobind from "react-autobind";
import _ from "lodash";
import * as serviceModuleActions from "./store/ServiceModules/actions";
import * as serviceModuleSelectors from "./store/ServiceModules/reducer";
class App extends Component {
  constructor(props) {
    super(props);

    this.props.dispatch(serviceModuleActions.getPortalSetting());
    autobind(this);
  }
  componentWillReceiveProps(nextProps, nextState) {
    if (
      this.props.portalSettings !== nextProps.portalSettings &&
      !_.isUndefined(nextProps.portalSettings)
    ) {
      document.title = nextProps.portalSettings.title;
    }
  }

  // moduleMenu() {
  //   const { modules } = this.state;

  //   return (
  //     <ModuleMenu
  //       modules={modules}
  //       handleModuleMenuSelected={e => this.handleModuleMenuSelected(e)}
  //     />
  //   );
  // }

  render() {
    return <div>{this.props.children}</div>;
  }
}
function mapStateToProps(state) {
  return {
    portalSettings: serviceModuleSelectors.loadPortalSttings(state)
  };
}
export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js